import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useMap } from "react-map-gl";
import { useMapStore } from "../..";
import ILayerProps from "../../interfaces/IlayerProps";
import { minZoom } from "../mapConfig";

function AADTMapLayer({ visible }: ILayerProps) {
    const map = useMap().current!;
    const mapStore = useMapStore();

    useEffect(() => {
        if (!mapStore.isStyleLoaded)
            return;

        map.getStyle()!.layers
            .filter((l: any) => l.metadata && l.metadata["mapbox:group"] === "f666d89404ae643315c3cc27232de451")
            .forEach(l => {
                map.getMap().setLayerZoomRange(l.id, minZoom.aadt, map.getMap().getLayer(l.id)!.maxzoom!);
                map.getMap().setLayoutProperty(l.id, "visibility", visible ? "visible" : "none");
            });
    }, [mapStore.isStyleLoaded, visible]);

    return (
        <></>
    );
}

export default observer(AADTMapLayer);